import { render, staticRenderFns } from "./leftColInfoA.vue?vue&type=template&id=7c62bf55"
import script from "./leftColInfoA.vue?vue&type=script&lang=js"
export * from "./leftColInfoA.vue?vue&type=script&lang=js"
import style0 from "./leftColInfoA.vue?vue&type=style&index=0&id=7c62bf55&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports